export default __webpack_public_path__ + "static/media/faceWhite.3c7a6fd8.svg";